import {
  Box,
  Center,
  Flex,
  Image,
  useRadio,
  useRadioGroup,
} from '@chakra-ui/react';
import { MaterialModel, MenuModel } from 'lib/api/model';
import { useEffect } from 'react';

function RadioCardSmMenuItem(props: any) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  return (
    <Box w={props.buttonSize.w} h={props.buttonSize.h} position="relative">
      <Box as="label">
        <input {...input} />
        <Center
          {...checkbox}
          cursor="pointer"
          borderWidth="1px"
          borderRadius="md"
          boxShadow="md"
          _checked={{
            bg: '#f9fefb',
            color: 'black',
            borderWidth: '2px',
            borderColor: 'mint.500',
          }}
          h="56px"
          fontSize="14px"
          fontWeight={'medium'}>
          {props.children}
        </Center>
      </Box>
    </Box>
  );
}

interface IRadioButtonsProps {
  radioGroupName: string;
  defaultValue?: string;
  buttonList: MenuModel[];
  buttonSize: { w: string; h: string };
  onChange: (value: string) => void;
}
function RadioButtonsSmMenuList({
  radioGroupName,
  defaultValue = '',
  buttonList,
  buttonSize,
  onChange,
}: IRadioButtonsProps) {
  const { getRootProps, getRadioProps, setValue } = useRadioGroup({
    name: radioGroupName,
    defaultValue: defaultValue,
    onChange: onChange,
  });

  const group = getRootProps();

  useEffect(() => {
    setValue('');
  }, [buttonList, setValue]);

  return (
    <Flex {...group} gap="10px" flexWrap={'wrap'}>
      {buttonList.map((buttonValue, index) => {
        const radio = getRadioProps({ value: buttonValue.name });
        return (
          <RadioCardSmMenuItem
            key={index}
            {...radio}
            buttonSize={buttonSize}
            item={buttonValue}>
            {buttonValue.name}
          </RadioCardSmMenuItem>
        );
      })}
    </Flex>
  );
}

export default RadioButtonsSmMenuList;
